/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-28 18:58:22
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-06 15:10:34
 * @FilePath: /dsicm-admin-web/src/views/newPatientmanage/api/index.js
 */
import request from '@/utils/req.js';

//病人管理分页列表适配admin2.0页面接口
export function apiPatientPage(params) {
    return request.post("/admin/patient/v2/page", params);
}

// 病人管理 患者列表分页第三版
export function apiPatientV3Page(params) {
    return request.post("/admin/patient/v3/page", params);
}

//医护团队列表查询
export function apiDoctorTeam(params) {
    return request.get("/admin/doctor-team", params);
}
//部门树查询
export function apiDepartmentTreeList(params) {
    return request.post("/admin/department/tree-list", params);
}
//新版病人管理查看档案接口
export function apiGetPatientArchvies(params) { 
    return request.get(`/admin/patient-archives/getPatientArchvies/${params}`);
}
//新版患者档案基本信息更新按钮
export function UpdatepatientArchiesLeft(params) {
    return request.post(`/admin/patient-archives/UpdatepatientArchiesLeft`, params);
}
//新版患者档案病历更新按钮
export function UpdatepatientArchiesRight(params) {
    return request.post(`/admin/patient-archives/UpdatepatientArchiesRight`, params);
}
// 获取某患者时间范围内的非计分问卷列表
export function qaGetList(params) {
    return request.post("/admin/qs-answer-sheet/getList", params);
}
// 获取某患者时间范围内的计分问卷列表
export function qagetCountScoreList(params) {
    return request.post("/admin/qs-answer-sheet/getCountScoreList", params);
}

// 新-计分
export function getQsAnswerSheetPageByUserId(params) {
    return request.post("/admin/qs-answer-sheet/getQsAnswerSheetPageByUserId", params);
}

// 获取某患者时间范围内的计分问卷xy
export function qagetExamPaperChart(params) {
    return request.post("/admin/qs-answer-sheet/getExamPaperChart", params);
}

export function getPatientRelationInspectionCategory(patientId) {
    return request.get(`/admin/disease-inspection/getPatientRelationInspectionCategory/${patientId}`);
}
export function getPatientDiseaseInspectionLogList(params) {
    return request.post("/admin/disease-inspection/getPatientDiseaseInspectionLogList", params);
}
export function getDiseaseInspectionChar(params) {
    return request.post("/admin/disease-inspection/getDiseaseInspectionChar", params);
}
export function getPhysicalSignMonitorData(params) {
    return request.post("/admin/patient-metadata/getPhysicalSignMonitorData", params);
}

// picc
export function getPiccVOByPatientId(patientId) {
    return request.get(`/admin/picc-cathetering-record/getPiccVOByPatientId/${patientId}`);
}

// icd-10数据查询接口
export function getFindIcdDiseaseByCondition(params) {
    return request.get("/dsicm-data-base/feign/disease-type/findIcdDiseaseByCondition", params)
}

export function patientArchivesAssistedReproduction(params) {
    // return request.post("/dsicm-archives/feign/patient-archives-assisted-reproduction", params)
    return request.post("/dsicm-api/feign/patient-archives-assisted-reproduction", params)
}

// 病人管理右侧数据接口
export function getPatientDetailedInformationVO(params) {
    return request.post("/admin/patient/getPatientDetailedInformationVO", params)
}

// 病人管理新增字段列表查询
export function getListByPatientId(params) {
    return request.get("/admin/terminology/getListByPatientId", params)
}

// 新增术语字段保存
export function terminologyMultipleInsert(params) {
    return request.post("/admin/terminology/multipleInsert", params)
}

// 获取当前患者关注病种
export function getFollowingListByPatient(params) {
    return request.get("/admin/disease-following/getFollowingList", params)
}

// 患者第三方资料审核记录分页查询
export function pageList(params) {
    return request.post("/admin/patient-archives-third-party-approval-record/page", params)
}
// 患者第三方资料审核记录分页查询
// export function exportUnpaidDataToExcel(params) {
//     return request.post("/admin/patient-archives-third-party-approval-record/exportUnpaidDataToExcel", params)
// }
// 导出订单汇总记录
export function exportUnpaidDataToExcel(params) {
    return request.postUpload(`/admin/patient-archives-third-party-approval-record/exportUnpaidDataToExcel`, params, { responseType:'arraybuffer' })
}

  // 审核通过拒绝
export function approve(params) {
    return request.put("/admin/patient-archives-third-party-approval-record/approve", params)
}
//获取所有地区列表
export function regionAll(params) {
    return request.get(`/patient/region/all`, params)
}
// 导入接口
export function importExcel(params) {
    return request.post("/admin/patient-archives-third-party/importExcel", params);
}

// 会员审核详情
export function getByApprovalRecordld(params) {
    return request.get('/admin/patient-archives-third-party-approval-record/getByApprovalRecordId',params); 
}
//患者新增病例时间
export function addPatientDate(params) {
    return request.post("/biz/patient-date-scheme-course-mapping/add-patient-date", params);
}
// 编辑患者病例时间 
export function upPatientDate(params) {
    return request.post("/biz/patient-date-scheme-course-mapping/update-patient-date", params);
}
// 删除患者病例时间 
export function delPatientDate(params) {
    return request.del("/biz/patient-date-scheme-course-mapping/del-patient-date", params);
}